export const waitFor = async function (timeMs: number): Promise<number> {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(1);
        }, timeMs);
    });
};
